<template>
    <div class="page greyBg">
      <pageTitle title='储值卡充值' />
      <div class="usermes whiteBg">
        <inputBox label="会员姓名" :disabled='true' hintMsg='会员姓名' :value='userName' />
        <inputBox label="会员卡号" :disabled='true' hintMsg='会员卡号' :value='this.userInfo.Card_no' />
        <inputBox label="手机号码" :disabled='true' hintMsg='手机号码' :value='this.userInfo.sjno' />
      </div>
        <div class="recommend whiteBg">
            <div class="radioArea" @click='changeRecommend'>
              <radioBtn :value='recommend' />
              员工推荐储值
            </div>
            <transition name="fade">
              <div v-if='recommend'>
                <inputBox label="酒店编号" :disabled='fromUrl' hintMsg='请输入酒店编号' v-model='hotelCode' />
                <inputBox label="员工卡号" :disabled='fromUrl' hintMsg='请输入员工卡号' v-model='employeeCode' />
              </div>
            </transition>
        </div>
        <div class = "money whiteBg">
            <span class="title">充值金额</span>
            <div class="items">
                <div v-on:click="money='300'" v-bind:class="{ selected: money=='300' }">
                    <h3>300元</h3>
                    <small>送300K币</small>
                </div>
                <div v-on:click="money='500'" v-bind:class="{ selected: money=='500' }">
                    <h3>500元</h3>
                    <small>送500K币</small>
                </div>
                <div v-on:click="money='1000'" v-bind:class="{ selected: money=='1000' }">
                    <h3>1000元</h3>
                    <small>送1000K币</small>
                </div>
            </div>
            <span class="title other">其他金额（单位：元）</span>
            <mu-auto-complete fullWidth hintText="3000" v-model="money" type="number"/>
            <div class="radioArea">
              <radioBtn :value='true' />
              消费时开发票
            </div>
        </div>
        <div class="rule whiteBg">
            <span class="title">充值条款：</span>
            <div class="content">
                1.请核对会员账户信息、充值金额、充值成功后无法取消、退款。<br/>
                2.关于充值优惠、发票、使用说明等会员储值细则请点击查看<router-link to="/wallet/valueCardRule">[查看储值优惠政策及使用规则]</router-link>，确认后再充值。<br/>
                <span v-if='fromUrl || recommend'>3.酒店编号：{{hotelCode}}&nbsp;&nbsp;员工卡号：{{employeeCode}}</span>
            </div>
            <div class="radioArea" @click="changeAgree">
              <radioBtn :value='agreeState' />
              我同意上述条款
            </div>
            <mu-raised-button v-on:click='post' v-bind:style="{ width:'90%',height:'50px',margin:'20px 5%'}" primary v-bind:label="'充值'+money+'元'"/>    
        </div>  
        <mu-toast id="alertline" v-if="toast" :message="hintMsg" @close="hideToast"/>
    </div>
</template>

<style lang="less" scoped>
@import "../../assets/theme.less";
.radioArea{
  font-size:0.3rem;
  color: #333333;
  display: flex;
  padding: 0.2rem 0 0.2rem 0.2rem;
  .radioBtn{
    margin: auto 0;
    margin-right:0.4em;
  }
}
.title {
  color: @primaryBlack;
  font-size: 0.3rem;
  font-weight: 500;
}
.usermes {
  margin-bottom: 0.2rem;
}
.recommend {
  color: #333333;
  margin-bottom: 0.2rem;
}
.money {
  padding: 0.2rem 0.2rem;
  margin-bottom: 0.2rem;
  .other {
    padding-top: 0.1rem;
  }
  .items{
    display: flex;
    justify-content: space-around;
    margin-bottom: 0.1rem;
    div {
      text-align: center;
      flex-wrap: wrap;
      flex-grow: 1;
      background-color: white;
      margin: 0.1rem;
      h3 {
        margin: 0 auto;
        color: @secondBlack;
      }
      small {
        margin: 0 auto;
      }
      border: 2px solid #ccc;
      color: black;
      border-radius: 4px;
      padding: 7px 0;
    }
    .selected {
      h3 {
        color: @primaryOrange;
      }
      color: @primaryOrange;
      border: 2px solid @primaryOrange;
      position: relative;
      background: linear-gradient(135deg, @transparent 85%, @primaryOrange 10%);
    }
    .selected:after {
      content: "√";
      color: white;
      position: absolute;
      right: 0;
      bottom: -4px;
    }
  }
}
.rule {
  padding: 0.2rem 0.2rem;
  .content {
    width: 100%;
    color: @secondBlack;
    margin: 0.1rem 0;
  }
  .agree {
    padding-top: 1em;
    padding-bottom: 0em;
  }
  .check {
    text-align: center;
  }
}
</style>


<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import api from "../../api/index.js";
import pageTitle from "../../components/pageTitle.vue";
import radioBtn from "../../components/radioBtn";

export default {
  data() {
    return {
      money: "300",
      agreeState: false,
      invoiceState: false,
      toast: false,
      disabled: false,
      hintMsg: "请先同意条款！",
      //酒店编码(在那个酒店充的值，url传入)
      hotelCode: "",
      //员工编码(哪个员工的绩效，url传入)
      employeeCode: "",
      //是否来自URL
      fromUrl: false,
      //是否使用员工推荐
      recommend: false,
      userName:''
    };
  },
  methods: {
    ...mapMutations({
      setMsg: "setG_rechargeMsg"
    }),
    showToast(hintMsg) {
      this.hintMsg = hintMsg
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => {
        this.toast = false
      }, 2000)
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    post(e) {
      var that = this;
      e.preventDefault();
      if(this.recommend){
        if(this.hotelCode == ''){
          this.showToast('请填写酒店编号！')
          return 
        }
        else if(this.employeeCode == ''){
          this.showToast('请填写员工卡号！')
          return
        }
      }
      if (this.agreeState == false) {
        this.showToast('请先同意充值条款！')
      } 
      else if (this.userInfo.Card_no == "" || typeof this.userInfo.Card_no == "undefined") 
      {
        this.showToast('您尚未登录，请先登录！')
        setTimeout(function() {
          that.$router.push({ path: "/user/Login" });
        }, 2000);
      }
      else {
        var params = new this.URLSearchParam();
        params.append("moneyRe", this.money);
        params.append("cardNo", this.userInfo.Card_no);
        params.append("hotelCode", this.hotelCode);
        params.append("employeeCode", this.employeeCode);
        this.$http
          .post(api.submitRechargeOrder(), params.toParam())
          .then(res => {
            if (res.Result) {
              var msg = {};
              msg.money = this.money;
              msg.id = res.Data;
              this.setMsg(msg);
              this.$router.push({ path: "/wallet/payStyle" });
            } 
            else {
              var that = this;
              this.showToast(res.Message);
              if(res.Message === '未登录'){
                setTimeout(function() {
                  that.$router.push({ path: "/user/Login" });
                }, 2000);
              }
            }
          });
      }
    },
    changeRecommend(){
      //路径带参数无法修改
      if(this.fromUrl){
        return
      }
      this.recommend = !this.recommend
    },
    changeAgree(){
      this.agreeState = !this.agreeState
    },
    //跳转登录页面
    goLogin(){
      var that = this;
      setTimeout(function() {
        that.$router.push({ path: "/user/Login" })
      }, 2000);
    }
  },
  computed: {
    ...mapGetters({
      msg: "g_rechargeMsg",
      userInfo: "g_UserInfo"
    })
  },
  components: {
    pageTitle,
    radioBtn,
  },
  activated() {
    var nowUrl=window.location.href;
    if(nowUrl.indexOf("http://h5.998.com/kosmos")>-1){
        nowUrl=nowUrl.replace('http://h5.998.com/kosmos','https://i.998.com')
        window.location.href=nowUrl;
    }
    var that = this
    if (this.userInfo.Card_no == "" || typeof this.userInfo.Card_no == "undefined") 
    {
      this.showToast('您尚未登录，请先登录！');
      this.goLogin();
      return;
    }
    else if(this.userInfo.HasOpenStoreCard === false){
      this.showToast('您尚未开通储值卡！')
      setTimeout(function() {
        that.$router.push({ path: "/wallet/openValueCard" })
      }, 2000);
      return;
    }
    else if(typeof this.userInfo.HasOpenStoreCard === "undefined"){
      this.showToast('您的用户信息已过期，请重新登录！');
      //清空信息缓存
      this.$store.commit('CLEARUSER');
      //跳转登录
      this.goLogin();
      return;
    }
    this.fromUrl = false
    this.recommend = false
    //如果没参数query===null
    var query = this.$route.query
    console.log(query)
    //如果有参数
    if (query != null) {
      //这里兼容参数大小写
      this.hotelCode = query.hotelCode || query.hotelcode
      this.employeeCode = query.employeeCode || query.employeecode
      if(typeof this.hotelCode === "undefined" || this.hotelCode.trim() === ''){
        this.hotelCode = ''
      }
      else{
        //获取到的编号没问题不准编辑
        this.fromUrl = true
        this.recommend = true
      }
    }
    this.userName = this.userInfo.Name
  }
};
</script>



// WEBPACK FOOTER //
// recharge.vue?06a37e10